import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import { getPracticeId, patientPhotoUrl } from "../../config/practice";

const ThyroidUltrasoundModal = ({ ismodal, setIsmodal, data }) => {
  const [showIsthmusComment, setShowIsthmusComment] = useState(false);
  const [showRtComment, setShowRtComment] = useState(false);
  const [showLtComment, setShowLtComment] = useState(false);
  const[isLoading,setIsLoading]=useState(false)
  const [providerList, setProviderList] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
const practiseid = getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const userConfig = useSelector((state) => state.userconfig);
  const calculateAge = (dob) => {
 
    const birthDate = dayjs(dob);
    const today = dayjs();
    return today.diff(birthDate, "year");
  };
useEffect(() => {
  if (ismodal) {
    getProviders();
  }
}, [ismodal]);

  const age = calculateAge(data?.dob);

  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    preliminary: "no",
    history: "",
    rtLobe: { L: "", W: "", H: "", comment: "", unit: "cm" },
    ltLobe: { L: "", W: "", H: "", comment: "", unit: "cm" },
    isthmus: { value: "", comment: "", unit: "cm" },
    impression: "",
    signature: "",
  })

  const handleChange = (section, field, value) => {
    if (["rtLobe", "ltLobe", "isthmus"].includes(section)) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    const errors = [];

    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.rtLobe.L || !formData.rtLobe.W || !formData.rtLobe.H)
      errors.push("All Rt Lobe fields are required.");
    if (!formData.ltLobe.L || !formData.ltLobe.W || !formData.ltLobe.H)
      errors.push("All Lt Lobe fields are required.");
    if (!formData.isthmus.value) errors.push("Isthmus field is required.");
    if (!formData.impression.trim()) errors.push("Impression is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");

    return errors;
  };

const handleSave = async() => {
  const errors = validateForm();
  if (errors.length > 0) {
    setToastMessage(errors[0]);
    setToastSeverity("error");
    setOpenToast(true);
  } else {
    try {
      setIsLoading(true)
      const selectedProvider = providerList.find(
  (p) => p.providername === formData.provider
);

         const payload = {
      patient_id: data?.patientid,
      pat_name: `${data?.firstname} ${data?.lastname}`,
      pat_dob: data?.dob,
      examDate: formData.examDate,
      pat_age: age,
      pat_gender: data?.gender?.toUpperCase(),
      providerid: selectedProvider?.providerid, // Assuming fixed provider ID; modify if dynamic
      providername: formData.provider,
      encounterid: data?.appointmentid,
      preliminary: formData.preliminary === "yes" ? "Yes" : "No",
      pathistory: formData.history,
      rtlobel: formData.rtLobe.L,
      rtlobew: formData.rtLobe.W,
      rtlobeh: formData.rtLobe.H,
      rtlobeComments: formData.rtLobe.comment,
      ltlobel: formData.ltLobe.L,
      ltlobew: formData.ltLobe.W,
      ltlobeh: formData.ltLobe.H,
      ltlobeComments: formData.ltLobe.comment,
      ishtmus: formData.isthmus.value,
      ishtmusComments: formData.isthmus.comment,
      rtlobeunits: formData.rtLobe.unit,
      ltlobeunits: formData.ltLobe.unit,
      ishtmusunits: formData.isthmus.unit,
      sonographersImpression: formData.impression,
      signature: formData.signature,
      imgtagsArr: tags.map((tag, index) => ({
        pic_id: index + 1,
        name: tag.text,
        x: Math.round(tag.x),
        y: Math.round(tag.y),
      })),
    };
      const user=await api.get('/auth/me')
const [year, month, day] = formData.examDate.split("-");
const formattedDate = `${month}/${day}/${year}`;
const resetFormData = () => {
  setFormData({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    preliminary: "no",
    history: "",
    rtLobe: { L: "", W: "", H: "", comment: "", unit: "cm" },
    ltLobe: { L: "", W: "", H: "", comment: "", unit: "cm" },
    isthmus: { value: "", comment: "", unit: "cm" },
    impression: "",
    signature: "",
  });

  setShowIsthmusComment(false);
  setShowRtComment(false);
  setShowLtComment(false);
  setTags([]);
  setCurrentTagText("");
  setClickPosition(null);
};

const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
  "Worksheet_Type": "THYROID_ULTRASOUND",
  "createdby": user?.username || '',
  "appurl": window.location.origin,
    // "appurl": "https://api.prd.brainymed.com",
  "Exam_Date": formattedDate,
  "data": payload
});

if(response.status==200){
  const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
  "filename": response?.data?.filename,

  "worksheet_type": "THYROID_ULTRASOUND",
   "appurl": window.location.origin,
  "exam_date": formattedDate
  })
  setToastMessage("Form Submitted Successfully");
    setToastSeverity("success");
    setOpenToast(true);
 setTimeout(() => {
  resetFormData()
  setIsmodal(false);
}, 1000);

}else{
  setToastMessage(response.message);
    setToastSeverity("info");
    setOpenToast(true);
}
    } catch (error) {
      console.log(error)
        setToastMessage("Something Went Wrong");
    setToastSeverity("error");
    setOpenToast(true);
    }finally{
setIsLoading(false)

    }
 
   

  
  }
};
const getProviders = async () => {
  try {
    const response = await api.get(`/v1/${practiseid}/providers`);
    if (response.status === 200 && Array.isArray(response.data)) {
      setProviderList(response.data);
    }
  } catch (error) {
    console.error("Error fetching providers:", error);
    setToastMessage("Failed to load providers");
    setToastSeverity("error");
    setOpenToast(true);
  }
};
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange(null, "provider", data.linked_provider);
    } else if (providerList.length > 0) {
      handleChange(null, "provider", providerList[0].providername);
    }
  }
}, [providerList, data]);



  // Tagging logic
  const [taggingMode, setTaggingMode] = useState(false);
  const [clickPosition, setClickPosition] = useState(null);
  const [tags, setTags] = useState([]);
  const [currentTagText, setCurrentTagText] = useState("");

  const handleImageClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setClickPosition({ x, y });
    setCurrentTagText("");
    setTaggingMode(true);
  };

  const handleTagSave = () => {
    if (currentTagText.trim()) {
      setTags([...tags, { ...clickPosition, text: currentTagText }]);
    }
    setTaggingMode(false);
  };

  const handleTagCancel = () => {
    setTaggingMode(false);
  };

  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">THYROID ULTRASOUND</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">
            &times;
          </button>
        </div>
        <hr className="mb-4 border-gray-300" />

        {/* Patient Info */}
        <div className="flex items-center space-x-4 mb-4">
          <img

            src={patientPhotoUrl(data.patientid)}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
          <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
  #{data?.patientid}
</div>

            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold"   >Age:</span> {age} &nbsp;|&nbsp;
              <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>

        {/* Provider and Exam Date */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
            <select
  className="w-full border rounded px-2 py-1"
  value={formData.provider}
  onChange={(e) => handleChange(null, "provider", e.target.value)}
>
  <option value="">Select Provider</option>
  {providerList.map((provider) => (
    <option key={provider.id} value={provider.providername}>
      {provider.providername}
    </option>
  ))}
</select>

          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input
              type="date"
              className="w-full border rounded px-2 py-1"
              value={formData.examDate}
              onChange={(e) => handleChange(null, "examDate", e.target.value)}
            />
          </div>
        </div>

        {/* Preliminary */}
        <div className="mt-4">
          <label className="block text-sm font-medium">Preliminary</label>
          <div className="flex space-x-4 mt-1">
            {["yes", "no"].map((val) => (
              <label key={val} className="flex items-center space-x-1">
                <input
                  type="radio"
                  name="preliminary"
                  value={val}
                  checked={formData.preliminary === val}
                  onChange={() => handleChange(null, "preliminary", val)}
                />
                <span>{val.charAt(0).toUpperCase() + val.slice(1)}</span>
              </label>
            ))}
          </div>
        </div>

        {/* History */}
        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea
            placeholder="Enter Patient History here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.history}
            onChange={(e) => handleChange(null, "history", e.target.value)}
          />
        </div>

        {/* Thyroid Image with Tags */}
        <div className="relative w-full max-h-[300px] mt-6 mb-4">
          <img
            src="https://cloud.brainymed.com/chim/public//assets/images/ThyroidUltrasound.jpeg?id=20250715"
            alt="Thyroid Diagram"
            className="w-full object-contain border rounded-md cursor-crosshair"
            onClick={handleImageClick}
          />

          {/* Tag Input Modal */}
          {taggingMode && clickPosition && (
            <div
              className="absolute bg-red-500 text-white p-2 rounded shadow-lg z-10"
              style={{
                left: clickPosition.x,
                top: clickPosition.y,
                transform: "translate(-50%, -100%)",
              }}
            >
              <div className="mb-1">Tag here</div>
              <input
                type="text"
                className="text-black px-1 rounded w-40"
                value={currentTagText}
                onChange={(e) => setCurrentTagText(e.target.value)}
              />
              <div className="mt-1 flex justify-between text-sm">
                  <button onClick={handleTagCancel}>Cancel</button>
                <button onClick={handleTagSave}>Save</button>
              
              </div>
            </div>
          )}

          {/* Render saved tags */}
          {tags.map((tag, index) => (
            <div
              key={index}
              className="absolute bg-yellow-200 text-black px-2 py-1 text-xs rounded shadow-md"
              style={{
                left: tag.x,
                top: tag.y,
                transform: "translate(-50%, -100%)",
                pointerEvents: "none",
              }}
            >
              {tag.text}
            </div>
          ))}
        </div>

        {/* Reusable for Rt Lobe and Lt Lobe */}
        {/* {["rtLobe", "ltLobe"].map((side, idx) => (
          <div key={side} className="grid grid-cols-5 gap-4 mb-2 items-end">
            <div>
              <label className="block text-sm font-medium mb-1">{side === "rtLobe" ? "Rt Lobe L" : "Lt Lobe L"}</label>
              <input   type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData[side].L}
                onChange={(e) => handleChange(side, "L", e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">{side === "rtLobe" ? "Rt Lobe W" : "Lt Lobe W"}</label>
              <input   type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData[side].W}
                onChange={(e) => handleChange(side, "W", e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">{side === "rtLobe" ? "Rt Lobe H" : "Lt Lobe H"}</label>
              <div className="flex items-center gap-2">
                <input   type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData[side].H}
                  onChange={(e) => handleChange(side, "H", e.target.value)} />
                <button
                  onClick={() => side === "rtLobe" ? setShowRtComment(!showRtComment) : setShowLtComment(!showLtComment)}
                  className="text-blue-600 hover:text-blue-800"
                >
                  <FaPlus />
                </button>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Units</label>
              <select className="border rounded px-2 py-1 w-full"
                value={formData[side].unit}
                onChange={(e) => handleChange(side, "unit", e.target.value)}>
                <option>cm</option>
                <option>mm</option>
              </select>
            </div>
          </div>
        ))}

        {showRtComment && (
          <textarea className="w-full border rounded px-2 py-1 mb-4" rows={2}
            value={formData.rtLobe.comment}
            onChange={(e) => handleChange("rtLobe", "comment", e.target.value)}
            placeholder="Rt Lobe H comment..."
          />
        )}
        {showLtComment && (
          <textarea className="w-full border rounded px-2 py-1 mb-4" rows={2}
            value={formData.ltLobe.comment}
            onChange={(e) => handleChange("ltLobe", "comment", e.target.value)}
            placeholder="Lt Lobe H comment..."
          />
        )} */}
        {["rtLobe", "ltLobe"].map((side, idx) => (
  <div key={side} className="mb-4">
    <div className="grid grid-cols-5 gap-4 items-end">
      <div>
        <label className="block text-sm font-medium mb-1">{side === "rtLobe" ? "Rt Lobe L" : "Lt Lobe L"}</label>
        <input
          type="number"
          step="0.01"
          inputMode="decimal"
          className="border rounded px-2 py-1 w-full"
          value={formData[side].L}
          onChange={(e) => handleChange(side, "L", e.target.value)}
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">{side === "rtLobe" ? "Rt Lobe W" : "Lt Lobe W"}</label>
        <input
          type="number"
          step="0.01"
          inputMode="decimal"
          className="border rounded px-2 py-1 w-full"
          value={formData[side].W}
          onChange={(e) => handleChange(side, "W", e.target.value)}
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">{side === "rtLobe" ? "Rt Lobe H" : "Lt Lobe H"}</label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            step="0.01"
            inputMode="decimal"
            className="border rounded px-2 py-1 w-full"
            value={formData[side].H}
            onChange={(e) => handleChange(side, "H", e.target.value)}
          />
          <button
            onClick={() =>
              side === "rtLobe"
                ? setShowRtComment(!showRtComment)
                : setShowLtComment(!showLtComment)
            }
            className="text-blue-600 hover:text-blue-800"
          >
            <FaPlus />
          </button>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Units</label>
        <select
          className="border rounded px-2 py-1 w-full"
          value={formData[side].unit}
          onChange={(e) => handleChange(side, "unit", e.target.value)}
        >
          <option>cm</option>
          <option>mm</option>
        </select>
      </div>
    </div>

    {(side === "rtLobe" && showRtComment) || (side === "ltLobe" && showLtComment) ? (
      <textarea
        className="w-full border rounded px-2 py-1 mt-2"
        rows={2}
        value={formData[side].comment}
        onChange={(e) => handleChange(side, "comment", e.target.value)}
        placeholder={side === "rtLobe" ? "Rt Lobe H comment..." : "Lt Lobe H comment..."}
      />
    ) : null}
  </div>
))}


        {/* Isthmus */}
        <div className="grid grid-cols-5 gap-4 mb-2 items-end">
          <div>
            <label className="block text-sm font-medium mb-1">Isthmus</label>
            <div className="flex items-center gap-2">
              <input className="border rounded px-2 py-1 w-full"
                type="number"
  step="0.01"
  inputMode="decimal"
                value={formData.isthmus.value}
                onChange={(e) => handleChange("isthmus", "value", e.target.value)} />
              <button
                onClick={() => setShowIsthmusComment(!showIsthmusComment)}
                className="text-blue-600 hover:text-blue-800"
              >
                <FaPlus />
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Units</label>
            <select className="border rounded px-2 py-1 w-full"
              value={formData.isthmus.unit}
              onChange={(e) => handleChange("isthmus", "unit", e.target.value)}>
              <option>cm</option>
              <option>mm</option>
            </select>
          </div>
        </div>

        {showIsthmusComment && (
          <textarea className="w-full border rounded px-2 py-1 mb-4" rows={2}
            value={formData.isthmus.comment}
            onChange={(e) => handleChange("isthmus", "comment", e.target.value)}
            placeholder="Isthmus comment..."
          />
        )}

        {/* Impression */}
        <div className="mb-4">
          <label className="block text-sm font-medium">Sonographer's Impression</label>
          <textarea
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            placeholder="Enter Sonographer's Impression here..."
            value={formData.impression}
            onChange={(e) => handleChange(null, "impression", e.target.value)}
          />
        </div>

        {/* Signature */}
        <div className="mb-6">
          <label className="block text-sm font-medium">Signature</label>
          <input
            className="w-full border rounded px-2 py-1 mt-1"
            placeholder="Signature"
            value={formData.signature}
            onChange={(e) => handleChange(null, "signature", e.target.value)}
          />
        </div>

        {/* Save Button */}
        <div className="flex justify-end">
          <button
            onClick={handleSave}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Save
          </button>
        </div>
      </div>
   <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
    </div>
  );
};

export default ThyroidUltrasoundModal;
